import { ethers } from "ethers";
import abi from "./GlobalPool.json";

const Buy1 = ({ state }) => {
  const buyChai = async (event) => {
    event.preventDefault();
    const { contract } = state;
    const contractABI = abi.abi;
    var name = document.querySelector("#pp").value;
    var pp5 = document.querySelector("#pp4").value;
    const refer = document.querySelector("#hid").value;
    console.log(name, contract);
    console.log(refer);
    console.log("hello");
     
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    function refreshPage() {
      window.location.reload(false);
    }
    
    const addressOfYourContract = '0xaeea5eb9282e8a10ffa2d6d1a98210e141ff8ae9';

      const busdContractAddress = '0x418e5662abD0dB9F67b43b0976B7B68b0a974978';
    const busdContractAbi = `[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balances","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}]`;

    function refreshPage() {
      window.location.reload(false);
    }
    
  
    const busdContract = new ethers.Contract(busdContractAddress, busdContractAbi, signer);
    
    const amountToApprove = ethers.utils.parseUnits('2560', 18);
    const allowance = await busdContract.allowance(signer.getAddress(), addressOfYourContract);
    if (allowance.lt(amountToApprove)) {
      const tx = await busdContract.approve(addressOfYourContract, amountToApprove, {
        gasLimit: 75000,
    });
      await tx.wait();
    }

    
    
//    function register1(address _refer,uint _amount,uint _per,uint _lev,uint _wid,uint _reward,address _team) payable public

// const transaction = await contract.register1('0x11cacC71af4b4F8d01Ed7112ADB0D234eD087eeC',100,125000000,379707,0,0,'0xdbcf3385cac823e00ccea17c260ae7388c9e4e76');
console.log(pp5);
if(pp5=="0x24f144699fE8A445bB391762eB1B569AC789AC45")
{

}
else if(pp5=="0xaD46B3E97B67cea35D6695E52273EAcfD8b13e38")
{

}
else if(pp5=="0x0b15F4dbb00ABc232fcA1a54aF1bdd829E7eb68E")
{
  
}
else if(pp5=="0xc412a7418e15472f238D2c55cc19cDf0D956b948")
{
  
}
else if(pp5=="0x6D81438659352bc8677BdB995a69F34BC87BBc26")
{
  
}
else if(pp5=="0x423e6ED8202dcA1D83E27B7f82dad11005DEd181")
{
  
}
else if(pp5=="0x3EFfC40A08303D5E8F8c87DB2972bd04d8685305")
{
  
}
else if(pp5=="0x901e6e9e52bdE4D856Bdf8A7147fA4B1ed45a01c")
{
  
}
else if(pp5=="0x63d9Adc06CDf01e291dd0D01Fa3Cf3cA6EAAce74")
{
  
}
else
{
  /*
    const transaction = await contract.trade(1, {
              gasLimit: 1200000,
          
        }); 
    await transaction.wait();
    */
    console.log("Transaction is done");
      }   
    refreshPage();
  };
  return (
    <>
     <div className="container-md" style={{ width: "100%", marginTop: "1px" }}>
        <form onSubmit={buyChai}>
        <input type="hidden" id ="name"></input>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center"}}>
  <button
  
    type="submit"
    id="sample"
    className="btn btn-accent-icon"
     style={{ backgroundColor: "yellowgreen", color: "white" }}
  >
    Trade
    
  </button>
</div>

        </form>
      </div>
    </>
  );
};
export default Buy1;